/* eslint-disable unicorn/no-array-reduce */
import { isEmpty } from 'remeda'
import type { MenuItem } from '@velasca/types'

const hasAMobileEntry = (entry: MenuItem): boolean | undefined => {
  if (entry.isMobile) {
    return true
  }

  return entry.children?.every((child) => hasAMobileEntry(child))
}

const strip = (menu: MenuItem[]) =>
  menu.reduce<MenuItem[]>((acc, entry) => {
    if (hasAMobileEntry(entry)) {
      return acc
    }

    if (!entry.children) {
      return [...acc, entry]
    }

    const strippedChildren: MenuItem[] = strip(entry.children)

    if (isEmpty(strippedChildren)) {
      return acc
    }

    return [...acc, { ...entry, children: strippedChildren }]
  }, [])

export default function clearMobileMenuEntries(menu?: MenuItem[]) {
  if (!menu) {
    return null
  }

  return strip(menu)
}
